import { HotelNavigationUtility } from "@b2bportal/core-utilities";
import type { OfferTemplate } from "@b2bportal/media-ads-api";
import { HOTELS_AVAILABILITY_PATH, HOTELS_PATH } from "@/utilities/constants";

// `targetProduct.productIdentifierType` value for a Google place id.
const PLACE_ID_IDENTIFIER_TYPE = "PlaceId";

/**
 * Hotel availability deep link for a sponsored offer's destination. Dates and
 * guests are left to the availability page defaults; the Google place id goes
 * in the `:placeId` segment so the search targets exactly that place. Falls
 * back to the hotel search home without a destination.
 */
export const getOfferHotelSearchPath = (offer: OfferTemplate): string => {
  const { targetProduct } = offer;
  const destination = targetProduct?.searchTerm;
  if (!destination) return HOTELS_PATH;

  const placeId =
    targetProduct.productIdentifierType === PLACE_ID_IDENTIFIER_TYPE
      ? targetProduct.productIdentifierValue
      : undefined;
  const segments = [
    HotelNavigationUtility.placeLabelToUrl(destination),
    ...(placeId ? [encodeURIComponent(placeId)] : []),
  ];
  return `${HOTELS_AVAILABILITY_PATH}/${segments.join("/")}`;
};
